import React from 'react'
import { useTranslation } from 'react-i18next'

import './GenerateBtnBox.scss'

const GenerateBtnBox = ({ createReferalLink, loadingSmall }: any) => {
	const { t } = useTranslation()

	return (
		<div className="d-flex flex-column justify-content-center GenerateBtnBox">
			{/* <p>{t('ReferFriendsDescGenerateUrl')}</p> */}
			<button
				type="button"
				className="btn btn-primary btnCreateLink"
				onClick={createReferalLink}>
				{loadingSmall ? (
					<div id="circle-spinner"></div>
				) : (
					t('ReferFriendsBtnGenerateUtl')
				)}
			</button>
		</div>
	)
}

export default GenerateBtnBox
